/*
 * @Author: Roman
 * @Date: 2023-02-22 14:50:51
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-05-25 13:56:18
 * @FilePath: \qpmn-site\language\en\rest.js
 * @Description: 
 */


exports.language = {
    /************************************ User ************************************/
    // 用户不存在
    3000001: "Current user data does not exist and has been deleted",



    /************************************ PropertyModel ************************************/
    2300065: "",
    /******************************* 获取builder地址接口错误 *******************************/
    178126: "Current productId not have ProductConfigView!",
    /******************************* Address 地址簿接口 *******************************/


    /******************************* 计价 *******************************/
    571826:"Missing product pricing config",

    /******************************* 日期格式 *******************************/
    600001:"Date type error",

    /******************************* freight 运费接口 *******************************/
    200454: "Config Error:The freight policy configuration is missing",
    
    /******************************* 店铺产品 接口 *******************************/
    

    /******************************* 货币 *******************************/ 
    300310:"Currency does not exist in the system."
};